import AbstractView from 'abstracts/AbstractView';
import Screen from "controllers/Screen";


export default class TransitionImages extends AbstractView {


	constructor($wrapper) {
		super();
		this.$wrapper = $wrapper;
		this.init();
	}

	initDOM() {
		this.$image = this.$wrapper.hasClass('img_lazy_container') ? this.$wrapper : this.$wrapper.find('.img_lazy_container');
	}

	initEl() {
		this.$image.each((index, image) => {
			const $image = $(image);
			$image.addClass('transition-image');
			this.tw['stOnTop' + index] = ScrollTrigger.create({
				trigger: $image,
				start: "top 75%",
				end: "bottom center",
				onEnter: () => {
					$image.addClass('show');
				}
			});
			this.tw['stOff' + index] = ScrollTrigger.create({
				trigger: $image,
				start: "top bottom",
				onLeaveBack: () => {
					$image.removeClass('show bottom top');
				}
			});
		});
	}
}
